export default "__VITE_ASSET__17299b73__"